import("../../../../Social-Sorbet/assets/js/splide.js")
	.then(({ Splide }) => {
		const sliders = document.querySelectorAll(".related-exhibitions .splide")
		const prefersReducedMotion =
			window.matchMedia("(prefers-reduced-motion: reduce)").matches ||
			document.documentElement.classList.contains("reduce-motion")

		for (let i = 0; i < sliders.length; i++) {
			const splideEl = sliders[i]

			const splide = new Splide(splideEl, {
				type: "slide",
				arrows: true,
				pagination: false,
				perPage: 3,
				perMove: 1,
				gap: "1.5rem",
				speed: prefersReducedMotion ? 0 : 400,
				mediaQuery: "min",
				destroy: true,
				i18n: {
					prev: "Previous exhibitions",
					next: "Next exhibitions",
					slideX: "Go to exhibition %s",
					pageX: "Go to page %s",
				},
				breakpoints: {
					768: {
						destroy: false,
						perPage: 2,
						gap: "1.56rem",
					},
					1440: {
						perPage: 3,
					},
				},
			})

			splide.mount()

			// role="region" with aria-label is sufficient — remove non-standard roledescription
			splideEl.removeAttribute("aria-roledescription")
		}
	})
	.catch((err) => {
		console.error(err)
	})
